import React from 'react';
import { NavLink } from 'react-router-dom';

const AddIpr5Crumb = () => <NavLink to="/human-resources/irp5s/add">Add IRP5</NavLink>;

export default AddIpr5Crumb;
